import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { SubstanceDrugsPublicSafetyModel } from './types';
import substanceDrugsPublicSafetyItemValidator from './validators/item';

const substanceDrugsPublicSafetyValidator: ValidateJSModel<SubstanceDrugsPublicSafetyModel> = {
  UsedDrugs: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.UsedDrugs && attributes?.UsedDrugs.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: substanceDrugsPublicSafetyItemValidator },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceDrugsPublicSafetyValidator;
